import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Dashboard Router - Redirects users to role-specific dashboards
 */
function Dashboard({ user, onLogout }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to role-specific dashboard
    if (!user || !user.role) {
      return;
    }

    const role = user.role.toLowerCase();

    // Route based on role
    if (role === 'admin') {
      navigate('/dashboard/admin', { replace: true });
    } else if (role === 'hr manager' || role === 'hr') {
      navigate('/dashboard/hr', { replace: true });
    } else if (role === 'manager') {
      navigate('/dashboard/manager', { replace: true });
    } else if (role === 'employee') {
      navigate('/dashboard/employee', { replace: true });
    } else {
      // Default to admin dashboard for other roles
      navigate('/dashboard/admin', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    </div>
  );
}

export default Dashboard;
